import React, { HTMLProps } from 'react';
import Option from './Option';

import './Select.scss';

export interface SelectProps extends HTMLProps<HTMLDivElement> {
  onChange?: (value: any) => void;
  defaultValue?: string | number;
  defaultText?: string;
}
export default class Select extends React.Component<SelectProps> {

  static Option = Option;

  wrapperRef = React.createRef<HTMLDivElement>();
  optionsRef = React.createRef<HTMLDivElement>();
  optionsHeight = 0;

  state = {
    value: undefined,
    isOpen: false
  }

  render() {
    let { isOpen } = this.state;
    let { defaultText, defaultValue, children: propsChildren, ...rest } = this.props;
    const children = React.Children.toArray(propsChildren) as any[];

    const height = isOpen ? this.optionsHeight + 'px' : 0;
    return (
      <div
        {...rest}
        className={"widget-select" + this.getOpenClass()}
        onClick={this.onClick} ref={this.wrapperRef}>
        <div className="widget-select-selector">
          <span>{this.getText()}</span>
          <span className="angle-wrapper">{this.renderAngle()}</span>
        </div>
        <div className="widget-select-options" ref={this.optionsRef} style={{ height }}>
          {children.map(child => (
            <div key={child.key}
              className="widget-option-item-wrapper"
              onClick={this.onChange.bind(this, child.props.value)}>
              {child}
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderAngle = () => {
    const { isOpen } = this.state;
    const rotate = isOpen ? ' fa-rotate-180' : '';
    return <i className={"far fa-angle-down" + rotate}></i>
  }

  getOpenClass = () => {
    const { isOpen } = this.state;
    return isOpen ? ' is-open' : '';
  }

  getText = () => {
    let { value } = this.state;
    const { defaultText, defaultValue, children: propsChildren } = this.props;
    const children = React.Children.toArray(propsChildren) as any[];
    if (value === undefined) {
      value = defaultValue;
    }
    if (defaultValue === undefined && children.length > 0) {
      value = children[0];
    }
    const found = (children as any[]).find(ch => ch.props.value === value);
    if (found) {
      return found.props.children;
    }
    return defaultText ?? '';
  }

  onClick = (event: React.MouseEvent) => {
    this.setState({ isOpen: !this.state.isOpen });
  }

  onChange = (value: string) => {
    this.setState({ isOpen: false, value });
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  }

  onOutsideClick = (event) => {
    if (this.wrapperRef) {
      const element = this.wrapperRef.current;
      if (!element.contains(event.target as Node))
        if (this.state.isOpen === true) {
          this.setState({ isOpen: false });
        }
    }
  }

  componentDidMount = () => {
    window.addEventListener('mousedown', this.onOutsideClick, true);
    if (this.optionsRef) {
      const element = this.optionsRef.current;
      this.optionsHeight = element.scrollHeight;
    }
  }

  componentDidUpdate = () => {
    if (this.optionsRef) {
      const element = this.optionsRef.current;
      this.optionsHeight = element.scrollHeight;
    }
  }

  componentWillUnmount = () => {
    window.removeEventListener('mousedown', this.onOutsideClick, true);
  }

}
